import { useMutation } from "@tanstack/react-query";

import * as subscriptionApi from "@core/apis/subscription.api";
import type { CommonUseMutationOptions } from "@core/types/app";

export default (options?: CommonUseMutationOptions) => {
  const mutation = useMutation({
    ...options,
    mutationFn: () => subscriptionApi.cancelSubscription(),
  });

  return mutation;
};
